import DeleteGenericModal from "../../../modals/DeleteGenericModal";
import ReactTable from "../../../util/ReactTable";
import AsyncBlock from "../../../components/forms/AsyncBlock";
import PageTitle from "../../../components/layout/PageTitle";
import PageSection from "../../../components/layout/PageSection";
import Button from "../../../components/forms/Button";
import PageContainerFull from "../../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../../components/flex/Flex";
import useDeleteModal from "../../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../../hooks/useFetch2";
import {Apis} from "../../../util/data";
import * as React from "react";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";

const PdfRiskList = () => {

  const navigate = useNavigate()
  const {id} = useParams()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/pdf/list/riesgo/' + id, []);

  const deleteElement = id => axios.delete(Apis.PROD + '/pdf/riesgo/' + id)

  function addPdfRisk() {
    navigate('/riesgos/'+ id+'/pdfs/new')
  }

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este pdf del riesgo?',
    action: deleteElement,
    onRefresh: fetchData
  })

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Codigo',
        accessorKey: 'codigo',
      },
      {
        header: 'Titulo',
        accessorKey: 'titulo',
      },
      {
        header: 'Url',
        accessorKey: 'url',
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageBackLabel text='Riesgos' onClick={() => navigate('/riesgos')}/>
        <PageTitle title={'Pdfs'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addPdfRisk()}
            noData='No existen pdfs registrados'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
    </PageContainerFull>
  )
}

export default PdfRiskList
